'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.guid = exports.elligibleForRenewal = exports.getPolicyDetails = exports.start = exports.expiry = exports.vehicleDescription = exports.fullName = exports.policyNumbers = exports.findFirstName = exports.lastName = exports.firstName = exports.policyStatus = exports.startDate = exports.renewDate = exports.vehicleModel = exports.contact = exports.regNo = exports.make = exports.policyNumber = exports.policyId = exports.policy = exports.policyById = undefined;
var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();
var _reselect = require('reselect');
var _inNoMoreThanDays = require('@marmalade/validation/lib/in-no-more-than-days');
var _inNoMoreThanDays2 = _interopRequireDefault(_inNoMoreThanDays);
var _customer = require('./customer');
var _check = require('@marmalade/form/lib/utils/check');
var _check2 = _interopRequireDefault(_check);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var hasProp = Object.prototype.hasOwnProperty;

// Gets a single policy througout all of the policies in state by id
var policyById = exports.policyById = function policyById(state, id) {
  var _reduce$filter = ['live', 'future', 'history'].reduce(function (acc, cur) {
      return acc.concat((0, _customer.customer)(state)[cur]);
    }, []).filter(function (policy) {
      return policy.id === id;
    }),
    _reduce$filter2 = _slicedToArray(_reduce$filter, 1),
    policy = _reduce$filter2[0];
  return policy;
};
var policy = exports.policy = function policy(state, _ref) {
  var type = _ref.type,
    _ref$position = _ref.position,
    position = _ref$position === undefined ? 0 : _ref$position;
  return (0, _customer.customer)(state)[type][position];
};
var policyId = exports.policyId = function policyId(state, _ref2) {
  var type = _ref2.type,
    _ref2$position = _ref2.position,
    position = _ref2$position === undefined ? 0 : _ref2$position;
  return policy(state, {
    type: type,
    position: position
  }).id;
};
var policyNumber = exports.policyNumber = function policyNumber(state, _ref3) {
  var type = _ref3.type,
    _ref3$position = _ref3.position,
    position = _ref3$position === undefined ? 0 : _ref3$position;
  return policy(state, {
    type: type,
    position: position
  }).policyNumber;
};
var make = exports.make = function make(state, _ref4) {
  var type = _ref4.type,
    _ref4$position = _ref4.position,
    position = _ref4$position === undefined ? 0 : _ref4$position;
  return policy(state, {
    type: type,
    position: position
  }).make;
};
var regNo = exports.regNo = function regNo(state, _ref5) {
  var type = _ref5.type,
    _ref5$position = _ref5.position,
    position = _ref5$position === undefined ? 0 : _ref5$position;
  return policy(state, {
    type: type,
    position: position
  }).regNo;
};
var contact = exports.contact = function contact(state, _ref6) {
  var type = _ref6.type,
    _ref6$position = _ref6.position,
    position = _ref6$position === undefined ? 0 : _ref6$position;
  return policy(state, {
    type: type,
    position: position
  }).contact;
};
var vehicleModel = exports.vehicleModel = function vehicleModel(state, _ref7) {
  var type = _ref7.type,
    _ref7$position = _ref7.position,
    position = _ref7$position === undefined ? 0 : _ref7$position;
  return policy(state, {
    type: type,
    position: position
  }).vehicleModel;
};
var renewDate = exports.renewDate = function renewDate(state, _ref8) {
  var type = _ref8.type,
    _ref8$position = _ref8.position,
    position = _ref8$position === undefined ? 0 : _ref8$position;
  return policy(state, {
    type: type,
    position: position
  }).renewDate;
};
var startDate = exports.startDate = function startDate(state, _ref9) {
  var type = _ref9.type,
    _ref9$position = _ref9.position,
    position = _ref9$position === undefined ? 0 : _ref9$position;
  return policy(state, {
    type: type,
    position: position
  }).startDate;
};
var policyStatus = exports.policyStatus = function policyStatus(state, _ref10) {
  var type = _ref10.type,
    _ref10$position = _ref10.position,
    position = _ref10$position === undefined ? 0 : _ref10$position;
  return policy(state, {
    type: type,
    position: position
  }).policyStatus;
};

// Contact selectors
var firstName = exports.firstName = function firstName(state, _ref11) {
  var type = _ref11.type,
    _ref11$position = _ref11.position,
    position = _ref11$position === undefined ? 0 : _ref11$position;
  return contact(state, {
    type: type,
    position: position
  }).firstName;
};
var lastName = exports.lastName = function lastName(state, _ref12) {
  var type = _ref12.type,
    _ref12$position = _ref12.position,
    position = _ref12$position === undefined ? 0 : _ref12$position;
  return contact(state, {
    type: type,
    position: position
  }).lastName;
};

// Used to get first name for top of dashboard page
var findFirstName = exports.findFirstName = function findFirstName(state) {
  var cust = (0, _customer.customer)(state);
  if (cust.live.length) {
    return firstName(state, {
      type: 'live'
    });
  }
  if (cust.future.length) {
    return firstName(state, {
      type: 'future'
    });
  }
  if (cust.history.length) {
    return firstName(state, {
      type: 'history'
    });
  }
  return firstName(state, {
    type: 'policy'
  });
};
var policyNumbers = exports.policyNumbers = (0, _reselect.createSelector)(_customer.customer, function (customer) {
  return {
    live: customer.live.length,
    future: customer.future.length,
    history: customer.history.length
  };
});
var fullName = exports.fullName = function fullName() {
  return (0, _reselect.createSelector)([firstName, lastName], function (firstName, lastName) {
    return firstName + ' ' + lastName;
  });
};
var vehicleDescription = exports.vehicleDescription = function vehicleDescription() {
  return (0, _reselect.createSelector)([regNo, make, vehicleModel], function (regNo, make, vehicle) {
    return Object.assign({
      regNo: regNo,
      make: make
    }, typeof vehicle !== 'undefined' && vehicle !== null ? {
      model: vehicle.fullModelName,
      description: vehicle.fullDerivative,
      year: vehicle.manufacturedFromYear + ' - ' + vehicle.manufacturedToYear
    } : {
      model: '',
      description: '',
      year: ''
    });
  });
};
var expiry = exports.expiry = function expiry() {
  return (0, _reselect.createSelector)(renewDate, function (renew) {
    var date = new Date(renew.year, renew.month - 1, renew.day - 1); // We want day before, so -1 on day, the -1 on month is because JS crazy
    return date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear();
  });
};
var start = exports.start = function start() {
  return (0, _reselect.createSelector)(startDate, function (begins) {
    var date = new Date(begins.year, begins.month - 1, begins.day);
    return date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear();
  });
};
var getPolicyDetails = exports.getPolicyDetails = function getPolicyDetails() {
  var name = fullName();
  var vehicleDesc = vehicleDescription();
  var expiryDate = expiry();
  var startDate = start();
  return (0, _reselect.createSelector)([name, policyNumber, vehicleDesc, expiryDate, startDate, policyStatus], function (fullName, policyNumber, vehicle, expiry, begins, status) {
    return Object.assign({
      Name: fullName,
      'Policy Number': policyNumber,
      Vehicle: vehicle,
      'Start Date': begins,
      Expiry: expiry
    }, status === 'CANCELLED' || status === 'VOID' ? {
      Status: status
    } : {});
  });
};
var elligibleForRenewal = exports.elligibleForRenewal = (0, _reselect.createSelector)(_customer.customer, function (customer) {
  if (customer.history.length && !customer.future.length && !customer.live.length) {
    // Has history, no active or live policies
    return true;
  }
  if (customer.live.length && !customer.future.length) {
    // If has live policy & no future policy
    var renews = customer.live[0].renewDate;
    if (!(0, _inNoMoreThanDays2.default)(30)([renews.day, renews.month, renews.year]).length) {
      // If renewal date is no more than 30 days in future from today
      return true;
    }
  }
  return false;
});
var guid = exports.guid = (0, _reselect.createSelector)(_customer.customer, function (customer) {
  if (hasProp.call(customer, 'live') && customer.live.length) {
    return customer.live[0].guid;
  }
  if (hasProp.call(customer, 'history') && customer.history.length) {
    return customer.history[0].guid;
  }
  if (hasProp.call(customer, 'future') && customer.future.length) {
    return customer.future[0].guid;
  }
  // Quotes

  if (hasProp.call(customer, 'quotes') && customer.quotes.length) {
    // set guid - use oldest one
    var _guid = customer.quotes[customer.quotes.length - 1].guid;
    for (var n = customer.quotes.length - 1; n >= 0; --n) {
      _guid = (0, _check2.default)(customer.quotes[n].guid) || _guid;
    }
    return _guid;
  }
  return undefined;
});